module.exports = __webpack_public_path__ + "img/monkey.d36b1aca.svg";